var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.27357 9.79066C9.17211 9.75833 8.53081 9.47662 8.93154 8.28948H8.9258C9.97037 7.24101 10.7686 5.55389 10.7686 3.89288C10.7686 1.33888 9.02598 0 7.00064 0C4.97402 0 3.24093 1.33826 3.24093 3.89288C3.24093 5.56073 4.03473 7.25469 5.08569 8.30067C5.49535 9.34789 4.76281 9.73656 4.60966 9.79066C2.48861 10.5388 0 11.9013 0 13.2464V13.7507C0 15.5833 3.64613 16 7.02042 16C10.3998 16 14 15.5833 14 13.7507V13.2464C14 11.8609 11.4993 10.5089 9.27357 9.79066ZM5.75378 15.2065C5.75378 13.6214 6.78943 11.4815 6.78943 11.4815L6.07284 10.9337C6.07284 10.41 7 9.86218 7 9.86218C7 9.86218 7.92461 10.4187 7.92461 10.9337L7.21058 11.4815C7.21058 11.4815 8.24622 13.6133 8.24622 15.2239C8.24622 15.4764 5.75378 15.4179 5.75378 15.2065Z",
    fill: "#130D38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminIcon);
export default __webpack_public_path__ + "static/media/admin-icon.a5dc1f6e6517e0a63791c3929c112b8c.svg";
export { ForwardRef as ReactComponent };